import * as apiServices from "./apiExportHelper";
import api from "@chronos/frontend-base/src/libs/api/Api";

export default function() {
  for (let service in apiServices) {
    const instance = apiServices[service];
    api.registerService(instance.name, instance);
  }
}
